import { render, staticRenderFns } from "./EmbroideryModal.vue?vue&type=template&id=16b6fcfd&scoped=true"
import script from "./EmbroideryModal.vue?vue&type=script&lang=js"
export * from "./EmbroideryModal.vue?vue&type=script&lang=js"
import style0 from "./EmbroideryModal.vue?vue&type=style&index=0&id=16b6fcfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b6fcfd",
  null
  
)

export default component.exports